import { RequestsTabType } from '../../../../Service/components/AdminTables/stores/AdminServiceTablesStore'

const includeStatuses: Record<
  RequestsTabType,
  Record<string, (string | number)[]>
> = {
  'все заявки': { statuses: [2, 4, 11, 5, 6, 7, 12, 13, 14, 15, 16] },
  назначены: {
    statuses: [2],
  },
  приняты: {
    statuses: [4],
  },
  'в работе': {
    statuses: [11],
  },
  установка: {
    statuses: [5],
  },
  установленные: {
    statuses: [6, 12, 13, 14, 15, 16],
  },
  'не выполненные': {
    statuses: [7],
  },
}

export const getValidStatusValues = (
  tab: RequestsTabType,
  items: any,
): any[] => {
  return items.filter((item: any) =>
    includeStatuses[tab].statuses?.includes(item?.id),
  )
}
